<app-navBar></app-navBar>
<app-header [message]="$any(['Services','For Business','Services'])"></app-header>
<app-business-main [message]="$any(['business'])"></app-business-main>
<app-footer></app-footer>
